import MainLayout from '../../Apps/Home/MainLayout';
import GuestRequest from '../../Apps/guestRequest/guestRequest';
import GuestRequestDetail from '../../Apps/guestRequest/guestRequestDetail';
import MyBill from '../../Apps/myBill/myBill';
import { CheckIn } from '../../Apps/checkedInScreens/booking';
import SubWidgetList from '../../components/widgetTypes/subWidgetlist';
import WelcomeScreen from '../../Apps/welcomeScreen/welcomeScreen';
import Notification from '../../Apps/notification/notification';
import NotificationDetail from '../../Apps/notification/notificationDetail';
import HCommerce from '../../Apps/h-commerce';
import HotelListWidget from '../../Apps/selectLocation/hotelListWidget';
import { TransitionPresets } from '@react-navigation/stack';
import { DoorKeyNavigator } from './doorKeyNavigator';
import GuestItinerary from '../../Apps/guestItinerary/guestItinerary';
import GuestItineraryDetails from '../../Apps/guestItinerary/guestItineraryDetails';
import IFrameViewer from '../../Apps/iFrameViewer/iFrameViewer';

// Pages Routes
export const HOME_PAGE = 'homepage';
export const WELCOME_SCREEN = 'welcome';

export const NOTIFICATION = 'notification';
export const NOTIFICATION_DETAIL = 'notificationdetail';

export const SUB_WIDGET_LIST = 'subwidgetlist';

export const CHECK_IN = 'checkin';

export const MY_BILL = 'mybill';

export const GUEST_REQUEST = 'guestrequest';
export const GUEST_REQUEST_DETAILS = 'guestrequestdetails';

export const LOYALTY_PROGRAM = 'loyaltyprogram';
export const LOYALTY_PROGRAM_NEW_JOIN  = 'loyaltyprogramnewjoin'
export const LOYALTY_PROGRAM_LOGIN = 'loyaltyprogramlogin';

export const TABLE_RESERVATION = 'tablereservation';
export const TABLE_RESERVATION_LIST_DETAILS = 'tablereservelistdetails';

export const HOTEL_SELECTOR_WIDGET = 'selecthotel';
export const DOOR_KEY_FLOW = 'doorKey';

export const HCOMMERCE = 'hcommerce';

export const GUEST_ITINERARY = 'myreservations';
export const GUEST_ITINERARY_DETAILS = 'myreservationdetails';

export const IFRAME_RENDERER = 'iframerenderer';

export const routes = [
    {
        name: WELCOME_SCREEN,
        component: WelcomeScreen
    },
    {
        name: HOME_PAGE,
        component: MainLayout,
        options: { gestureEnabled: false, ...TransitionPresets.ModalSlideFromBottomIOS }, // Disable gestures for this screen
    },
    {
        name: SUB_WIDGET_LIST,
        component: SubWidgetList,
        options: { ...TransitionPresets.RevealFromBottomAndroid },
    },
    {
        name: NOTIFICATION,
        component: Notification,
    },
    {
        name: NOTIFICATION_DETAIL,
        component: NotificationDetail
    },
    {
        name: CHECK_IN,
        component: CheckIn
    },
    {
        name: MY_BILL,
        component: MyBill
    },
    {
        name: GUEST_REQUEST,
        component: GuestRequest
    },
    {
        name: GUEST_REQUEST_DETAILS,
        component: GuestRequestDetail
    },
    {
        name: HCOMMERCE,
        component: HCommerce,
        options: { gestureEnabled: false }
    },
    {
        name: HOTEL_SELECTOR_WIDGET,
        component: HotelListWidget,
        options: {
            gestureDirection: "horizontal-inverted"
        }
    },
    {
        name: DOOR_KEY_FLOW,
        component: DoorKeyNavigator, 
        options: { gestureEnabled: false, ...TransitionPresets.ModalFadeTransition },
    },
    {
        name: GUEST_ITINERARY,
        component: GuestItinerary 
    },
    {
        name: GUEST_ITINERARY_DETAILS,
        component: GuestItineraryDetails
    },
    {
        name: IFRAME_RENDERER,
        component: IFrameViewer
    }
]